import PropTypes from 'prop-types';
import React from 'react';
import { List, Record } from 'immutable';
import classNames from 'classnames';

import IconBetBuilder from '../../../../../images/icons/misc/icon-bet-builder.svg';
import PromoIcon from '../../../../../images/betslip/UI_promos.svg';

import styles from './BetBuilderLegs.module.scss';

const BetBuilderLegs = ({
  betType,
  betBuilderLegs,
  betBuilderLegsExpanded,
  betBuilderLegsWithErrors,
  handleBetBuilderLegsAccordion,
  offer
}) => {
  const mainClass = classNames({
    [styles.main]: true,
    [styles[`main--${betType}`]]: true
  });

  const betBuilderLegsClass = classNames({
    [styles.containerBetBuilderLegs]: true,
    [styles['containerBetBuilderLegs--toExpand']]: betBuilderLegs.size > 3,
    [styles['containerBetBuilderLegs--expanded']]: betBuilderLegsExpanded,
  });

  return (
    <div className={mainClass}>
      {offer.useBonus && <PromoIcon className={styles.promoIcon} />}
      <IconBetBuilder className={styles.sourceIcon} />
      <div className={betBuilderLegsClass}>
        <div>
          {betBuilderLegs.map(leg => {
            const legError = betBuilderLegsWithErrors.includes(leg);
            const betBuilderLegClass = classNames({
              [styles.betBuilderLeg]: true,
              [styles['betBuilderLeg--invalid']]: legError,
              [styles['betBuilderLeg--ellipsed']]: !betBuilderLegsExpanded,
            });

            return (
              <div key={leg} className={betBuilderLegClass}>
                <span>{leg}</span>
              </div>
            );
          })}
        </div>
        {betBuilderLegs.size > 3 && (
          <button onClick={handleBetBuilderLegsAccordion}>
            {betBuilderLegsExpanded
              ? 'Collapse'
              : `+${betBuilderLegs.size - 2} More`}
          </button>
        )}
      </div>
    </div>
  );
};

BetBuilderLegs.propTypes = {
  betType: PropTypes.oneOf(['unsubmitted', 'active']),
  betBuilderLegs: PropTypes.instanceOf(List).isRequired,
  betBuilderLegsWithErrors: PropTypes.array.isRequired,
  betBuilderLegsExpanded: PropTypes.bool.isRequired,
  handleBetBuilderLegsAccordion: PropTypes.func.isRequired,
  offer: PropTypes.instanceOf(Record),
};

export default BetBuilderLegs;

